import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const StepBack: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['line', { x1: '18', x2: '18', y1: '20', y2: '4' }],
    ['polygon', { points: '14,20 4,12 14,4' }],
  ],
];

export default StepBack;
